import {offsetThickness, verticalAxisThickness, horizontalAxisThickness} from '../../modules/axis';

function setVal(_val) {
  let val = Object.assign({},_val);
  if (val.orient && val.orient === 'x') { //legacy : 기존에는 orient에 값 넘기는 경우 있었음
    val.target = val.orient;
    val.orient = 'bottom';
  } else if (val.orient && val.orient === 'y') {
    val.target = val.orient;
    val.orient = 'left';
  } 

  let isHorizontal = val.target === 'x';
  if (!('showDomain' in val)) val.showDomain = true;
  if (!('showTicks' in val)) val.showTicks = true;
  if (!('showTitle' in val)) val.showTitle = true;
  if (!('orient' in val)) val.orient = (isHorizontal ? 'bottom' : 'left'); // x축일 경우 기본 bottom;
  if (!('thickness' in val)) {
    val.thickness = (isHorizontal ? horizontalAxisThickness : verticalAxisThickness);
    val.thickness += val.tickPadding ? val.tickPadding : 0;
    val.thickness += val.showTitle ? offsetThickness * 2: 0;
    val.thickness += val.showTicks ? offsetThickness : 0;
    val.defaultThickness = val.thickness;
  }
  
  return val;
}
function axis (_val, adding = true) { //axis 토글 {target, orient, thickness}
  //기본적으로 x,y 받고 axis가 많이 필요한 경우는 override 해서 y -> y1,y2 등으로 변환해야함(예. par-coords)
  if(!arguments.length) return this.__attrs__.axisToggle;
  let val;
  if (Array.isArray(_val)) {
    this.__attrs__.axisToggle = _val.map(setVal);
    _val.forEach(d=> this.__execs__.axis[d.target] = {});
    return this;
  } else if (typeof _val === 'string') {
    val = {target: _val};
    val = setVal(val);
  } else if (typeof _val === 'object') {
    val = Object.assign({},_val);
    val = setVal(val);
  } 
  let findIndex = this.__attrs__.axisToggle.findIndex(d => d.target === val.target && d.orient === val.orient);
  if (adding) {
    if (findIndex >= 0) {
      this.__attrs__.axisToggle.splice(findIndex, 1, val);
    } else {
      this.__attrs__.axisToggle.push(val); //__attrs__ 에는 존재 여부만 저장
    }
    if (!this.__execs__.axis[val.target]) this.__execs__.axis[val.target] = {}; //__setting에 공간 열어두기
  } else {
    if (findIndex >= 0) {
      this.__attrs__.axisToggle.splice(findIndex, 1);
    }
  }
  
  return this;
}

export default axis;


// WEBPACK FOOTER //
// ./layouts/rectLinear/axis.js